import { requestToJoinOrganisation } from './joinOrganisation';
import createOrganisation from "./createOrganisation";

const organisationAPI = {
    create: createOrganisation,
    join: requestToJoinOrganisation
}

export default organisationAPI;